// extracted by mini-css-extract-plugin
export default {"root":"dashboardRoot_root__hnDtN"};